export const addChartFilterGroupName = (dataSetName: string, groupId: string, groupName: string) => {
	return {
		type: "ADD_CHART_FILTER_GROUPNAME",
		payload: { dataSetName, groupId, groupName },
	};
};

export const addChartFilterTabTileName = (dataSetName: string, tabTileName: string) => {
	return {
		type: "ADD_CHART_FILTER_TABTILENAME",
		payload: { dataSetName, tabTileName },
	};
};

export const updateChartFilterGroupsFilters = (dataSetName: string, groupId: string, filters: any) => {
	return {
		type: "UPDATE_CHART_FILTER_GROUPS_FILTERS",
		payload: { dataSetName, groupId, filters },
	};
};

export const updateChartFilterRightGroupsFilters = (groupId: string, item: any, groupEdited: boolean = true) => {
	return {
		type: "UPDATE_CHART_FILTER_RIGHT_GROUPS_FILTERS",
		payload: { groupId, item, groupEdited },
	};
};

export const updateChartFilterGroupsName = (groupId: string, name: string) => {
	return {
		type: "UPDATE_CHART_FILTER_GROUPS_NAME",
		payload: { groupId, name },
	};
};

export const updateChartFilterField = (groupKey: string, filterIndex: number, newValues: any) => ({
	type: 'UPDATE_CHART_FILTER_FIELD',
	payload: { groupKey, filterIndex, newValues },
});

export const deleteItemfromChartFilter = (groupKey: string, filterIndex: number) => {
	return {
		type: "DELETE_ITEM_FROM_FILTER_GROUP",
		payload: { groupKey, filterIndex },
	};
}

export const updateChartFilterGroupsCollapsed = (groupId: string, collapsed: boolean) => {
	return {
		type: "UPDATE_CHART_FILTER_GROUPS_COLLAPSED",
		payload: { groupId, collapsed },
	};
};

export const updateChartFilterSelectedGroups = (tabTileName: string, selectedGroups: any) => {
	return {
		type: "UPDATE_CHART_FILTER_SELECTED_GROUPS",
		payload: { tabTileName, selectedGroups },
	};
};

export const duplicateChartFilterGroups = (tabTileName: string, selectedGroups: any) => {
	return {
		type: "DUPLICATE_CHART_FILTER_GROUPS",
		payload: { tabTileName, selectedGroups },
	};
};

export const deleteChartFilterSelectedGroup = (tabTileName: string, groupIndex: number) => {
	return {
		type: "DELETE_CHART_FILTER_SELECTED_GROUP",
		payload: { tabTileName, groupIndex },
	};
};


export const deleteRightFilterGroupItems = (groupId: string, itemIndex: number) => {
	return {
		type: "DELETE_RIGHT_FILTER_GROUP_ITEM",
		payload: { groupId, itemIndex },
	};
};

export const chartFilterGroupEdited = (isEdited: boolean) => {
	return {
		type: "CHART_FILTER_GROUP_EDITED",
		payload: { isEdited },
	};
};


export const sortRightFilterGroupItems = (
	groupId: string,
	dragUId: string | number,
	dropUId: string | number
) => {
	return {
		type: "SORT_RIGHT_FILTER_GROUP_ITEMS",
		payload: { groupId, dragUId, dropUId },
	};
};

export const revertRightFilterGroupItems = (
	groupId: string,
	uId: string | number,
	originalIndex: any
) => {
	return {
		type: "REVERT_RIGHT_FILTER_GROUP_ITEMS",
		payload: { groupId, uId, originalIndex },
	};
};

export const loadReportFilterGroup = (chartFilterGroup: any) => {
	return { type: "LOAD_REPORT_FILTER_GROUP", payload: chartFilterGroup };
};
export const deleteFilterGroupFromChartFilterGroup = (groupId: string) => {
	return { type: "DELETE_FILTER_GROUP_FROM_CHART_FILTER_GROUP", payload: groupId };
}
export const resetChartFilterGroup = () => {
	return { type: "RESET_CHART_FILTER_GROUP" }
}

export const setSyncFilterGroup = (groupId: string, syncFilter: boolean) => {
	return { type: "SET_SYNC_FILTER", payload: { groupId, syncFilter } }
}

export const updateChartFilterAnyConditionMatch = (
  groupId: string,
  any_condition_match: boolean,
  groupEdited: boolean = true,
) => {
  return {
    type: 'UPDATE_CHART_FILTER_ANY_CONDITION_MATCH',
    payload: { groupId, any_condition_match, groupEdited },
  };
};


export const setLastModifiedFilter = (groupId: string, lastModifiedFilterUid: null | string, groupEdited: boolean = true) => {
	return { type: "SET_LAST_MODIFIED_FILTER_UID", payload: { groupId, lastModifiedFilterUid, groupEdited } }
}

export const setOptionsAndSelections = (groupID: string, options: any, selection: any, filterUid: string) => {
	return { type: "SET_RAW_OPTIONS_USER_SELECTION", payload: { groupID, options, selection, uid: filterUid } }
}
export const setFiltersOfGroup = (groupId: string, filters: any[]) => {
	return {
		type: "SET_CHART_FILTER_GROUPS_FILTERS",
		payload: { groupId, filters }
	}
}
export const changeDatasetOfFilterGroup = (groupId: string, dataSetId: string) => {
	return {
		type: "CHANGE_DATASET_OF_FILTER_GROUP",
		payload: { groupId, dataSetId }
	}
}
/**
 * 
 * @param datasetId 

 * @returns a action object with type "SET_DATASET_GROUP_LIST" and payload as datasetId
	it will intoduce datasetId in the state as a key to datasetGroupsList and the value is empty array
 */
export const setDatasetGroupList = (datasetId: string) => {
	return {
		type: "SET_DATASET_GROUP_LIST",
		payload: datasetId
	}
}